import PageMaxContainer from '@/components/pageMaxContainer/PageMaxContainer';
import './index.less';
import SearchView from '@/components/searchView/SearchView';
import { useGlobalOpenSearch } from '@/store/commonStore';
import DrawerUI from '@/componentsUI/Drawer';
import classNames from 'classnames';
import React, { useRef } from 'react';

const SearchDrawer = (props) => {
  const { style, className, innerRef } = props;
  const parentRef = useRef(null);
  const [searchVisible, setSearchVisible] = useGlobalOpenSearch();
  const prefixCls = 'search-drawer';
  return (
    <>
      <div className={`${prefixCls}-parent`} ref={parentRef}></div>
      <DrawerUI
        title={null}
        className={classNames([className, prefixCls])}
        style={style}
        visible={searchVisible}
        popupContainerFallback={parentRef.current}
        footer={null}
        closable={false}
        height={'100%'}
        placement={'top'}
        zIndex={100}
        focusLock={true}
        autoFocus={false}
        maskClosable={true}
        onCancel={() => setSearchVisible(false)}
        onOk={() => setSearchVisible(false)}
        unmountOnExit={true}
      >
        <div
          className={'search-inner'}
          ref={innerRef}
        >
          <PageMaxContainer>
            <SearchView visible={searchVisible} onCancel={() => setSearchVisible(false)} />
          </PageMaxContainer>
        </div>
      </DrawerUI>
    </>
  );
};

export default SearchDrawer;
